// Boundary — a passage a material makes, carrying an enforcement mode.
//
// `docs/model/constraints.md` §Severity versus Enforcement / §Boundaries.
// `enforcement` is a property of WHERE a material is moving, not of the
// policy. It composes with a membership's `Severity` (`./policy.ts`) to
// decide the outcome (`./evaluate.ts`):
//
//     severity \ enforcement | gate  | advisory
//     hard                    | block | warn
//     soft                    | warn  | warn
//
// The two decided boundaries:
//   - **write** — authoring. Enforcement is `advisory` (owner P7):
//     nothing blocks while authoring, so iteration never stalls on
//     half-finished material. Every draft violation is a warning.
//   - **export-to-<format>** — leaving the system as bytes. Enforcement
//     is `gate`, but opt-in and OFF by default (owner Q1). Export lets
//     the author through with warnings unless the gate is switched on.
//
// The opt-in / OFF-by-default nature of the export gate is modelled as
// TWO distinct export variants rather than a boolean flag
// (distinct-variants-per-intent): the shell builds `exportAdvisory`
// unless the author opted the gate on, in which case `exportGate`. That
// keeps "OFF by default" a shell decision and `enforcementFor` a total
// pure function.
//
// Pure module.
export { enforcementFor, exportAdvisory, exportGate, write };
import { exhaustSwitchCase } from "@bilda/utils";
const write = () => ({ type: "boundary_write" });
const exportAdvisory = (format) => ({
    type: "boundary_export_advisory",
    format,
});
const exportGate = (format) => ({
    type: "boundary_export_gate",
    format,
});
// === enforcementFor ===
//
// Total pure resolver. Only the opted-on export gate enforces; write and
// the default export are advisory.
const enforcementFor = (boundary) => {
    switch (boundary.type) {
        case "boundary_write":
            return "advisory";
        case "boundary_export_advisory":
            return "advisory";
        case "boundary_export_gate":
            return "gate";
        default:
            return exhaustSwitchCase(boundary);
    }
};
//# sourceMappingURL=boundary.js.map